import { defineMessages } from 'react-intl'

const messages = defineMessages({
  scoreBased: {
    id: 'global.score-based',
  },
  reviews: {
    id: 'global.reviews',
  },
})

export default messages
